import {Component} from '@angular/core';
import {CustomerService} from '../customer/customer.service';

@Component({
  selector: 'app-assignment-customer-form',
  templateUrl: './assignment-customer-form.component.html'
})
export class AssignmentCustomerFormComponent {

  constructor(
    public crudService: CustomerService
  ) {}
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment-customer-form.component.ts